module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'j68zqayj',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
